import { concatMap, map, of, withLatestFrom } from 'rxjs';

import { Injectable } from '@angular/core';
import {
  BilancioConsolidatoApiClient,
  ChiusuraRipristinoEsercizioApiClient,
  RiepilogoProspettiApiClient,
} from '@ideapa/app-api-client';
import { AuthFacade } from '@ideapa/app-auth';
import { NgrxLoaderFacade } from '@ideapa/app-ngrx-loader';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { pessimisticUpdate } from '@ngrx/router-store/data-persistence';

import * as CustomActions from './check-bilanci.actions';

@Injectable()
export class CheckBilanciEffects {
  constructor(
    private actions$: Actions,
    private loaderFacade: NgrxLoaderFacade,
    private chiusuraRipristinoEsercizioService: ChiusuraRipristinoEsercizioApiClient,
    private consolidatoService: BilancioConsolidatoApiClient,
    private authFacade: AuthFacade,
    private riepilogoProspettiService: RiepilogoProspettiApiClient
  ) {}

  // check consolidato
  checkConsolidato$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomActions.checkConsolidato),
      concatMap((a) =>
        of(a).pipe(withLatestFrom(this.authFacade.anno$, this.authFacade.ente$))
      ),
      pessimisticUpdate({
        run: (action, anno, ente) => {
          this.loaderFacade.showLoader(action);
          return this.consolidatoService.checkConsolidato(action.anno).pipe(
            map((consolidato) => {
              this.loaderFacade.hideLoader(action);
              return CustomActions.checkConsolidatoSuccess({
                exists: consolidato ? true : false,
                closed: consolidato ? consolidato.chiuso : false,
                anno: action.anno || anno,
                enteId: ente?.id || null,
              });
            })
          );
        },
        onError: (action, error) => {
          this.loaderFacade.hideLoader(action);
          return CustomActions.checkConsolidatoFailure({
            error,
          });
        },
      })
    )
  );

  // check esercizio chiuso
  checkEsercizioChiuso$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomActions.checkEsercizioChiuso),
      concatMap((a) =>
        of(a).pipe(withLatestFrom(this.authFacade.anno$, this.authFacade.ente$))
      ),
      pessimisticUpdate({
        run: (action, anno, ente) => {
          this.loaderFacade.showLoader(action);
          return this.chiusuraRipristinoEsercizioService
            .checkEsercizioClosed()
            .pipe(
              map((closed) => {
                this.loaderFacade.hideLoader(action);
                return CustomActions.checkEsercizioChiusoSuccess({
                  closed: closed,
                  anno,
                  enteId: ente?.id || null,
                });
              })
            );
        },
        onError: (action, error) => {
          this.loaderFacade.hideLoader(action);
          return CustomActions.checkEsercizioChiusoFailure({
            error,
          });
        },
      })
    )
  );

  // check dati riepilogo modificati
  checkDatiRiepilogoModificati$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomActions.checkDatiRiepilogoModificati),
      // concatMap((a) =>
      //   of(a).pipe(withLatestFrom(this.authFacade.anno$, this.authFacade.ente$))
      // ),
      pessimisticUpdate({
        run: (action) => {
          this.loaderFacade.showLoader(action);
          return this.riepilogoProspettiService
            .checkDatiRiepilogoModificati()
            .pipe(
              map((modificati) => {
                this.loaderFacade.hideLoader(action);
                return CustomActions.checkDatiRiepilogoModificatiSuccess({
                  modificati: modificati,
                });
              })
            );
        },
        onError: (action, error) => {
          this.loaderFacade.hideLoader(action);
          return CustomActions.checkDatiRiepilogoModificatiFailure({
            error,
          });
        },
      })
    )
  );
}
